export default __webpack_public_path__ + "static/media/profile-menu-expand-icon.434ba2a5.svg";